<template>
    <span>
        <button
            v-if="type === 'deactivate'"
            class="btn btn-sm btn-danger"
            type="button"
            @click="openModal()"
        >
            <i class="fa fa-ban"></i>
            <span class="sr-only">Deactivate</span>
        </button>
        <button
            v-else-if="type === 'activate'"
            class="btn btn-sm btn-success"
            type="button"
            @click="openModal()"
        >
            <i class="fa fa-check"></i>
            <span class="sr-only">Activate</span>
        </button>
    </span>
</template>

<script>
export default {
    data() {
        return {
            modal: {
                'class': 'modal-lists',
                'header': '',
                'body': '',
                'isBodyHtml': true,
                'id': '',
                'active': '',
            }
        }
    },
    props: {
        'id': Number,
        'type': String,
        'route': Object,
    },
    methods: {
        click: function () {
            this.$emit('modalEmitData', this.modal);
            return this.$emit('click');
        },
        emitModalData: function () {
            return this.$emit('modalEmitData', this.modal);
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        openModal: function () {
            this.click();
            this.modal = this[this.type]();
            this.emitModalData();
        },
        activate() {
            return {
                header: 'Activate Account #' + this.id,
                bodyHeader: '',
                body: 'Confirm the Account activation please.',
                btnColor: '',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: '',
                denyText: '',
                method: 'PUT',
            }
        },
        deactivate() {
            return {
                header: 'Deactivate Account #' + this.id,
                bodyHeader: '',
                body: 'Confirm the Account deactivation please.',
                btnColor: '',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: '',
                denyText: '',
                method: 'PUT',
            }
        },
    },
}
</script>
